module.exports = __webpack_public_path__ + "static/media/orange_nebula_FT.4fcc72e2.png";